export default "__VITE_ASSET__Q28TR2_w__"